"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import Image from "next/image";
import { WaitlistModal } from "@/components/waitlist-modal";
interface ComingSoonPageProps {
  sportName: string;
  waitlistType: string;
  iconSrc: string;
}
export function ComingSoonPage(t0) {
  const $ = _c(24);
  const {
    sportName,
    waitlistType,
    iconSrc
  } = t0;
  const [showWaitlistModal, setShowWaitlistModal] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setShowWaitlistModal(false);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `${sportName} Coming Soon`;
  const t3 = `We are currently working on adding support for ${sportName}. Join the waitlist to get notified as soon as it's ready!`;
  let t4;
  if ($[1] !== showWaitlistModal || $[2] !== t2 || $[3] !== t3 || $[4] !== waitlistType) {
    t4 = <WaitlistModal isOpen={showWaitlistModal} onClose={t1} title={t2} description={t3} type={waitlistType} />;
    $[1] = showWaitlistModal;
    $[2] = t2;
    $[3] = t3;
    $[4] = waitlistType;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      animation: "fadeSlideUnblur 1s ease-out 0.6s forwards"
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = `${sportName} Icon`;
  let t7;
  if ($[7] !== iconSrc || $[8] !== t6) {
    t7 = <Image src={iconSrc} alt={t6} width={48} height={48} className="w-10 h-10 sm:w-12 sm:h-12 object-contain" />;
    $[7] = iconSrc;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== sportName || $[11] !== t7) {
    t8 = <h1 className="text-4xl sm:text-5xl font-sriracha tracking-tighter text-[#B0D18B] mb-4 opacity-0 blur-md translate-y-8 flex items-center justify-center gap-4" style={t5}>{t7}{sportName}</h1>;
    $[10] = sportName;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      animation: "fadeSlideUnblur 1s ease-out 0.8s forwards"
    };
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <br />;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== sportName) {
    t11 = <p className="mt-4 text-base sm:text-lg lg:text-xl font-geist text-[#C4C8BA] opacity-0 blur-md translate-y-8 max-w-2xl mx-auto" style={t9}>{sportName} support is coming soon to MVPlayer. {t10}We are working hard to bring the best scoring experience to your favorite sport.</p>;
    $[15] = sportName;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="mt-8 opacity-0 blur-md translate-y-8" style={{
      animation: "fadeSlideUnblur 1s ease-out 1.0s forwards"
    }}><button onClick={() => setShowWaitlistModal(true)} className="bg-[#B0D18B] hover:bg-[#9DC077] text-[#1A1C16] font-bold py-3 px-8 rounded-full transition-all hover:scale-105 active:scale-95 shadow-[0_0_20px_rgba(176,209,139,0.3)] font-geist">Notify Me When Ready</button></div>;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t11 || $[19] !== t8) {
    t13 = <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-6 pb-24"><div className="text-center mb-16">{t8}{t11}{t12}</div></section>;
    $[18] = t11;
    $[19] = t8;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t13 || $[22] !== t4) {
    t14 = <div className="animate-in fade-in duration-500">{t4}{t13}</div>;
    $[21] = t13;
    $[22] = t4;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  return t14;
}